import React, { useState, useEffect, useCallback } from 'react';
import Modal from '../modal/Modal';
import { strings } from '../../localization/localization';

function RenameOptionValueModal({ option, optionValue, isOpen, onCancel, onConfirm, ...rest }) {
  const [name, setName] = useState(!!optionValue ? optionValue.name : '');

  useEffect(() => {
    if (!!optionValue) {
      setName(optionValue.name);
    }
  }, [optionValue]);

  const handleKeyDown = useCallback((event) => {
    if (event.key === 'Enter') {
      onConfirm(name);
    }
  }, [name, onConfirm]);

  if (!option || !optionValue) return null;

  return (
    <Modal
      title={strings.RenameOptionValueModal.bulkSetInventoryLevels}
      isOpen={isOpen}
      buttons={[
        {
          style: 'white',
          text: strings.RenameOptionValueModal.cancel,
          onClick: () => {
            onCancel();
          }
        },
        {
          style: 'black',
          text: strings.RenameOptionValueModal.set,
          onClick: () => {
            onConfirm(name);
          },
        }
      ]}
      onRequestClose={() => {
        onCancel();
      }}
      autoFocus={false}
      {...rest}
    >
      <h3>{strings.RenameOptionValueModal.rename} {option.name}: {optionValue.name}</h3>
      <input
        type="text"
        value={name}
        onChange={e => setName(e.target.value)}
        onKeyDown={handleKeyDown}
        autoFocus={true}
      />
    </Modal>
  );
}

RenameOptionValueModal.defaultProps = {
  isOpen: false,
  onCancel: () => {},
  onConfirm: () => {}
};

export default RenameOptionValueModal;
